import { CanActivateFn } from '@angular/router';
import { environment } from 'src/environments/environment';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const productionGuard: CanActivateFn = (route, state) => {
	return !environment.production;
};
